import { Component } from '@angular/core';

@Component({
  selector: 'app-buy-crypto',
  templateUrl: './buy-crypto.component.html',
  styleUrls: ['./buy-crypto.component.css']
})
export class BuyCryptoComponent {

}
